app.controller("SudoProgramsIndexController", ["$scope", "$q", "ProgramService", "$stateParams", "StaticData", "ConfirmModal", "$uibModal", "$state", "usSpinnerService", "toastr",
    function ($scope, $q, ProgramService, $stateParams, StaticData, ConfirmModal, $uibModal, $state, usSpinnerService, toastr) {
        $scope.programs = [];
        $scope.itemsPerPage = 25;
        $scope.query = $stateParams.query;
        $scope.selectionState = $stateParams.selectionState;
        $scope.selectionStates = [{name:'სტატუსი'}, {name: 'აქტიური', value: true}, {name: 'არააქტიური', value: false}];
        $scope.selectedLevels = [];
        $scope.selectedFaculties = [];

        function fillFilterFields() {
            if ($stateParams.faculty) {
                var faculty = $stateParams.faculty;
                faculty = typeof faculty === 'string' ? [faculty] : faculty;
                $scope.selectedFaculties = $scope.faculties.filter(function (f) {
                    return faculty.indexOf(f._id) > -1
                });
            }

            if ($stateParams.level) {
                var level = $stateParams.level;
                level = typeof level === 'string' ? [level] : level;
                $scope.selectedLevels = $scope.levels.filter(function (l) {
                    return level.indexOf(l._id) > -1
                });
            }
        }

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        function loadPage(page, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            ProgramService.activeForRegisterList({
                page: page,
                limit: $scope.itemsPerPage,
                query: $stateParams.query,
                faculty: $stateParams.faculty,
                level: $stateParams.level,
                selectionState: $scope.selectionState
            }).then(function (data) {
                $scope.programs = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $q.all([
            StaticData.getItemsByKey("faculties"),
            StaticData.getItemsByKey("levels"),
        ]).then(function (results) {
            var faculties = results[0];
            var levels = results[1];

            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');

            $scope.levels = [{name: "საფეხური"}].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');

            fillFilterFields();
        });

        $scope.addFacultyToFilter = function () {
            if ($scope.selectedFaculties.map(function(fac){return fac._id}).indexOf($scope.faculty) > -1) return;
            $scope.selectedFaculties.push($scope.faculties.find(function (f) {
                return f._id === $scope.faculty
            }));
            $scope.faculty = $scope.faculties[0]._id;
            $scope.applyFilter();
        };

        $scope.removeFaculty = function (fac) {
            $scope.selectedFaculties = $scope.selectedFaculties.filter(function (f) {
                return f !== fac
            });
            $scope.applyFilter();
        }

        $scope.addLevelToFilter = function () {
            if ($scope.selectedLevels.map(function(s){return s._id}).indexOf($scope.level) > -1) return;
            $scope.selectedLevels.push($scope.levels.find(function (s) {
                return s._id === $scope.level
            }));
            $scope.level = $scope.levels[0]._id;
            $scope.applyFilter();
        };

        $scope.removeLevel = function (lev) {
            $scope.selectedLevels = $scope.selectedLevels.filter(function (l) {
                return l !== lev
            });
            $scope.applyFilter();
        }

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                faculty: $scope.selectedFaculties.length ? $scope.selectedFaculties.map(function (f) {
                    return f._id;
                }) : undefined,
                level: $scope.selectedLevels.length ? $scope.selectedLevels.map(function (l) {
                    return l._id;
                }) : undefined,
                selectionState: $scope.selectionState
            });
        };

        $scope.activate = function (programId) {
            ProgramService.activateForRegister(programId).then(function() {
                toastr.success('', 'პროგრამის აქტივაცია წარმატებით დასრულდა');
                loadPage();
            })
        }

        $scope.deactivate = function (programId) {
            ProgramService.deactivateForRegister(programId).then(function() {
                toastr.success('', 'პროგრამის დეაქტივაცია წარმატებით დასრულდა');
                loadPage();
            })
        }

        $scope.deactivateAll = function () {
            ConfirmModal.show({
                title: "პროგრამების დეაქტივაცია",
                message: "გსურთ ყველა პროგრამების დეაქტივაცია?"
            }).result.then(function () {
                ProgramService.deactivateAllForRegister().then(function() {
                    toastr.success('', 'პროგრამების დეაქტივაცია წარმატებით დასრულდა');
                    loadPage();
                })
            });
        }
    }
]);
